import { Link, useNavigate } from "react-router-dom";
import { MapPin, Store } from "lucide-react";
import { img } from "@/lib/api";
import { dist, money, offerText } from "@/lib/format";
import { Countdown } from "./bits";
import { ShareMenu } from "./ShareMenu";

export const DealCard = ({ deal, index = 0 }) => {
  const nav = useNavigate();
  return (
    <article
      data-testid={`deal-card-${deal.id}`}
      style={{ animationDelay: `${Math.min(index, 8) * 60}ms` }}
      className="group bg-white border border-slate-200/80 rounded-2xl shadow-sm hover:shadow-xl hover:-translate-y-1 transition-[transform,box-shadow] duration-300 overflow-hidden flex flex-col animate-rise"
    >
      <Link to={`/deals/${deal.slug}`} className="relative block aspect-[4/3] overflow-hidden bg-slate-100" data-testid={`deal-card-link-${deal.id}`}>
        {deal.images?.[0] && <img src={img(deal.images[0])} alt={deal.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />}
        <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full text-xs font-extrabold bg-gradient-to-r from-red-600 to-orange-500 text-white shadow">{offerText(deal)}</span>
        <div className="absolute top-3 right-3"><ShareMenu deal={deal} testid={`deal-card-share-${deal.id}`} /></div>
        <div className="absolute bottom-3 left-3"><Countdown to={deal.expires_at} testid={`deal-card-countdown-${deal.id}`} /></div>
      </Link>
      <div className="p-4 flex flex-col gap-2 flex-1">
        <h3 className="font-heading font-bold text-slate-900 leading-snug line-clamp-2">{deal.title}</h3>
        <div className="flex items-center gap-1.5 text-sm text-slate-600"><Store className="w-4 h-4 text-slate-400" /><span className="truncate">{deal.merchant_name}</span></div>
        <div className="flex items-center gap-1.5 text-xs text-slate-500">
          <MapPin className="w-3.5 h-3.5 text-red-500" />
          <span className="truncate">{deal.branch_name}</span>
          {deal.distance_m != null && <span data-testid={`deal-card-distance-${deal.id}`} className="ml-auto font-bold text-slate-800 whitespace-nowrap">{dist(deal.distance_m)}</span>}
        </div>
        <div className="flex items-end justify-between mt-auto pt-2">
          <div>
            {deal.offer_price != null && <div className="font-heading text-lg font-extrabold text-slate-900">{money(deal.offer_price)}</div>}
            {deal.original_price != null && deal.offer_price != null && <div className="text-xs text-slate-400 line-through">{money(deal.original_price)}</div>}
          </div>
          <button data-testid={`deal-card-claim-button-${deal.id}`} onClick={() => nav(`/deals/${deal.slug}?claim=1`)} className="px-4 py-2 rounded-full bg-red-500 hover:bg-red-600 text-white text-sm font-bold active:scale-95 transition-transform">
            Claim Deal
          </button>
        </div>
      </div>
    </article>
  );
};
